import React, { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import DeadlineList, { daysTo } from "@/components/contract/DeadlineList";
import { CalendarClock } from "lucide-react";

const FILTERS = [["open", "Da fare"], ["soon", "Entro 30 giorni"], ["done", "Completate"], ["all", "Tutte"]];

export default function Deadlines() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");
  const [filter, setFilter] = useState("open");

  useEffect(() => {
    api.get("/deadlines").then((r) => setRows(r.data)).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, []);

  const shown = (rows || []).filter((r) =>
    filter === "all" ? true : filter === "done" ? r.done : filter === "soon" ? !r.done && daysTo(r.date) <= 30 : !r.done);

  return (
    <div className="p-6 lg:p-10 max-w-4xl mx-auto">
      <h1 className="text-3xl font-extrabold text-navy tracking-tight flex items-center gap-3"><CalendarClock className="text-primary" /> Scadenze contratti</h1>
      <p className="text-muted-foreground mt-1 mb-6">Rinnovi, disdette, fine sconti e pagamenti trovati dall'AI nei contratti firmati.</p>
      {error && <p className="text-destructive font-semibold" data-testid="deadlines-error">{error}</p>}
      {!error && (
        <>
          <div className="flex flex-wrap gap-2 mb-6">
            {FILTERS.map(([k, l]) => (
              <button key={k} onClick={() => setFilter(k)} data-testid={`deadline-filter-${k}`}
                className={`px-4 py-1.5 rounded-full text-sm font-bold border transition-colors duration-200 ${filter === k ? "bg-navy text-white border-navy" : "bg-white text-navy border-border hover:border-navy"}`}>
                {l}
              </button>
            ))}
          </div>
          {rows === null ? <p className="text-muted-foreground">Caricamento...</p> : (
            <DeadlineList items={shown} showClient
              onToggled={(r, done) => setRows((all) => all.map((x) => (x.id === r.id && x.offer_id === r.offer_id ? { ...x, done } : x)))} />
          )}
        </>
      )}
    </div>
  );
}
